export function hasIntersectionObserver(): boolean {
  const hasIntersection = 'IntersectionObserver' in window;
  const userAgent = window.navigator.userAgent;
  const matches = userAgent.match(/Edge\/(\d*)\./i);
  const isEdge = !!matches && matches.length > 1;
  const isEdgeVersion16OrBetter = isEdge && (!!matches && parseInt(matches[1], 10) > 15);

  return hasIntersection && (!isEdge || isEdgeVersion16OrBetter);
}

export function hasTouchScreen(): boolean {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || (navigator as any).msMaxTouchPoints > 0;
}
